import { createSlice } from '@reduxjs/toolkit';
import invariant from 'invariant';
import { toggleSort } from '../../components/Grid/utils';
const InitialState = {};
export const getDefaultData = ()=>({
        selectedItemId: null,
        filter: '',
        activePage: 1,
        pageSize: null,
        columnFilters: {},
        sort: null
    });
const gridSlice = createSlice({
    name: 'grid',
    initialState: InitialState,
    reducers: {
        clear (state, action) {
            delete state[action.payload.id];
            return state;
        },
        mergeProperties (state, action) {
            state[action.payload.id] = state[action.payload.id] || getDefaultData();
            state[action.payload.id] = {
                ...state[action.payload.id],
                ...action.payload.data
            };
            return state;
        },
        columnFilterChange (state, action) {
            state[action.payload.id] = state[action.payload.id] || getDefaultData();
            if (!action.payload.value) {
                delete state[action.payload.id].columnFilters[action.payload.columnId];
            } else {
                state[action.payload.id].columnFilters[action.payload.columnId] = {
                    type: action.payload.filterType,
                    value: action.payload.value
                };
            }
            return state;
        },
        toggleSort (state, action) {
            state[action.payload.id] = state[action.payload.id] || getDefaultData();
            state[action.payload.id].sort = toggleSort(state[action.payload.id].sort || [], action.payload.columnId);
            return state;
        },
        setSort (state, action) {
            state[action.payload.id] = state[action.payload.id] || getDefaultData();
            state[action.payload.id].sort = action.payload.sort;
            return state;
        },
        clearSort (state, action) {
            state[action.payload.id] = state[action.payload.id] || getDefaultData();
            state[action.payload.id].sort = null;
            return state;
        }
    }
});
export const gridReducer = gridSlice.reducer;
export const { mergeProperties } = gridSlice.actions;
export const GridActions = {
    clear (id) {
        invariant(id, 'id is missing.');
        return gridSlice.actions.clear({
            id
        });
    },
    setFilter (id, filter) {
        invariant(id, 'id is missing.');
        return gridSlice.actions.mergeProperties({
            id,
            data: {
                filter
            }
        });
    },
    setSelectedItemId (id, selectedItemId) {
        invariant(id, 'id is missing.');
        return gridSlice.actions.mergeProperties({
            id,
            data: {
                selectedItemId
            }
        });
    },
    setActivePage (id, activePage) {
        invariant(id, 'id is missing.');
        invariant(activePage, 'activePage is missing.');
        return gridSlice.actions.mergeProperties({
            id,
            data: {
                activePage
            }
        });
    },
    setPageSize (id, pageSize) {
        invariant(id, 'id is missing.');
        invariant(pageSize, 'pageSize is missing.');
        return gridSlice.actions.mergeProperties({
            id,
            data: {
                pageSize
            }
        });
    },
    setColumnFilters (id, columnFilters) {
        invariant(id, 'id is missing.');
        invariant(columnFilters, 'columnFilters is missing.');
        return gridSlice.actions.mergeProperties({
            id,
            data: {
                columnFilters
            }
        });
    },
    columnFilterChange (id, columnId, filterType, value) {
        invariant(id, 'id is missing.');
        invariant(columnId, 'columnId is missing.');
        invariant(filterType, 'filterType is missing.');
        return gridSlice.actions.columnFilterChange({
            id,
            columnId,
            filterType,
            value
        });
    },
    toggleSort (id, columnId) {
        invariant(id, 'id is missing.');
        invariant(columnId, 'columnId is missing.');
        return gridSlice.actions.toggleSort({
            id,
            columnId
        });
    },
    setSort (id, sort) {
        invariant(id, 'id is missing.');
        invariant(sort, 'sort is missing.');
        return gridSlice.actions.setSort({
            id,
            sort
        });
    },
    clearSort (id) {
        invariant(id, 'id is missing.');
        return gridSlice.actions.clearSort({
            id
        });
    }
};
